import { apiClient } from '../../lib/api-client';
import type {
  NurseryChildPayload,
  NurseryListResponse,
  NurseryLookupOption,
  NurseryResponse,
} from './types';

export const fetchNurseryChildren = async (page: number, limit: number, search: string, sortBy?: string | null, sortOrder?: 'asc' | 'desc') => {
  const response = await apiClient.get<NurseryListResponse>('/nursery/children', {
    params: { page, limit, ...(search ? { search } : {}), ...(sortBy ? { sortBy, sortOrder } : {}) },
  });
  return response.data;
};

export const fetchNurseryChild = async (childId: string) => {
  const response = await apiClient.get<NurseryResponse>(`/nursery/children/${childId}`);
  return response.data.data;
};

export const createNurseryChild = async (payload: NurseryChildPayload) => {
  const response = await apiClient.post<NurseryResponse>('/nursery/children', payload);
  return response.data.data;
};

export const updateNurseryChild = async (childId: string, payload: NurseryChildPayload) => {
  const response = await apiClient.patch<NurseryResponse>(`/nursery/children/${childId}`, payload);
  return response.data.data;
};

export const removeNurseryChild = async (childId: string) => {
  await apiClient.delete(`/nursery/children/${childId}`);
};

export const fetchNurseryDoctors = async () => {
  const response = await apiClient.get<{ success: true; data: NurseryLookupOption[] }>('/nursery/lookups/doctors');
  return response.data.data;
};
